"use strict";

var _glamor = require("glamor");

exports.onClientEntry = function () {
  if (window._glamor) {
    (0, _glamor.rehydrate)(window._glamor);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-glamor/gatsby-browser.js
// module id = ./node_modules/gatsby-plugin-glamor/gatsby-browser.js
// module chunks = 231608221292675